type CurrencyMapEntry = {
  position: 'front' | 'back';
  hasSpacing: boolean;
  name: string;
  symbol: string; // The actual string symbol
  [key: string]: any; // For any other properties
};

type CurrencyMap = Record<string, CurrencyMapEntry>;

export class CurrencyConstant {
  public static get CURRENCIES(): CurrencyMap {
    return {
      AED: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Dirham',
        symbol: 'د.إ',
      }, // د.إ 100.000
      ALL: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Albanian lek',
        symbol: 'L',
      }, // L 100.000
      AMD: {
        position: 'back',
        hasSpacing: false, // hasSpacing: true
        name: 'Armenian dram',
        symbol: '֏',
      }, // 500,000.00 ֏
      AOA: {
        position: 'front',
        hasSpacing: false,
        name: 'Angolan kwanza',
        symbol: 'Kz',
      }, // Kz1.000.000
      ARS: {
        position: 'front',
        hasSpacing: false,
        name: 'Argentine peso',
        symbol: '$',
      }, // $1.000.000,00
      AUD: {
        position: 'front',
        hasSpacing: false,
        name: 'Australian dollar',
        symbol: '$',
      }, // $1,000.00
      AZN: {
        position: 'front',
        hasSpacing: false,
        name: 'Azerbaijani manat',
        symbol: '₼',
      }, // ₼8,000.00
      BAM: {
        position: 'back',
        hasSpacing: false, // hasSpacing: true
        name: 'Bosnia & Herzegovina',
        symbol: 'KM', // Name updated from CSV
      }, // 1.000,00 KM
      BDT: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Bangladeshi taka',
        symbol: '৳',
      }, //  ৳10,000.00
      BGN: {
        position: 'back',
        hasSpacing: false, // hasSpacing: true
        name: 'Bulgarian lev',
        symbol: 'лв',
      }, // 500,00 лв
      BIF: {
        position: 'back',
        hasSpacing: false, // hasSpacing: true
        name: 'Burundian franc',
        symbol: 'FBu',
      }, // 4,000,000 FBu
      BMD: {
        position: 'front',
        hasSpacing: false,
        name: 'Bermudian dollar',
        symbol: '$',
      }, // $1,000.00
      BND: {
        position: 'front',
        hasSpacing: false,
        name: 'Brunei Dollar',
        symbol: '$',
      }, // $1,000.00
      BOB: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Bolivian boliviano',
        symbol: 'Bs',
      }, // Bs 1.000,00
      BRL: {
        position: 'front',
        hasSpacing: false,
        name: 'Brazilian real',
        symbol: 'R$',
      }, // R$5.000,00
      BSD: {
        position: 'front',
        hasSpacing: false,
        name: 'Bahamian dollar',
        symbol: '$',
      }, // $1,000.00
      BYN: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Belarusian ruble',
        symbol: 'Br',
      }, // Br 1'000.00
      CAD: {
        position: 'front',
        hasSpacing: false,
        name: 'Canadian dollar',
        symbol: '$',
      }, // $1,000.00
      CDF: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Congolese franc',
        symbol: 'FC',
      }, // FC 4.000.000
      CHF: {
        position: 'back',
        hasSpacing: false,
        name: 'Swiss franc',
        symbol: 'Fr',
      }, // 1'000.00Fr
      CLP: {
        position: 'front',
        hasSpacing: false,
        name: 'Chilean peso',
        symbol: '$',
      }, // $1.000.000
      CNY: {
        position: 'front',
        hasSpacing: false,
        name: 'Renminbi',
        symbol: '¥',
      }, // ¥7,000.00
      COP: {
        position: 'front',
        hasSpacing: false,
        name: 'Colombian peso',
        symbol: '$',
      }, // $4.000.000
      CRC: {
        position: 'front',
        hasSpacing: false,
        name: 'Costa Rican colón',
        symbol: '₡',
      }, // ₡1.000.000
      CZK: {
        position: 'back',
        hasSpacing: false,
        name: 'Czech koruna',
        symbol: 'Kč',
      }, // 20 000,00Kč
      DKK: {
        position: 'front',
        hasSpacing: false,
        name: 'Danish krone',
        symbol: 'kr.',
      }, // kr.7.000,00
      DOP: {
        position: 'front',
        hasSpacing: false,
        name: 'Dominican peso',
        symbol: '$',
      }, // $120,000.00
      DZD: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Algerian dinar',
        symbol: 'دج',
      }, // دج 100.000
      EGP: {
        position: 'front',
        hasSpacing: false,
        name: 'Egyptian pound',
        symbol: '£',
      }, // £15,000.00
      ETB: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Ethiopian birr',
        symbol: 'Br',
      }, // Br 100,000.00
      EUR: {
        position: 'front',
        hasSpacing: false,
        name: 'Euro',
        symbol: '€',
      }, // €1.000,00
      FJD: {
        position: 'front',
        hasSpacing: false,
        name: 'Fijian dollar',
        symbol: 'FJ$',
      }, // FJ$8,000.00
      FTN: {
        position: 'back',
        hasSpacing: false, // hasSpacing: true
        name: 'FastToken',
        symbol: '⚡︎',
      }, // 229.1234 ⚡︎
      GBP: {
        position: 'front',
        hasSpacing: false,
        name: 'Sterling',
        symbol: '£',
      }, // £1,000.00
      GEL: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Georgian lari',
        symbol: '₾',
      }, // ₾3 000,00
      GHS: {
        position: 'front',
        hasSpacing: false,
        name: 'Ghanaian cedi',
        symbol: '₵',
      }, // ₵20,000.00
      GMD: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Gambian dalasi',
        symbol: 'D',
      }, // D 140,000
      GNF: {
        position: 'back',
        hasSpacing: false,
        name: 'Guinean franc',
        symbol: 'FG',
      }, // 10.000.000FG
      GTQ: {
        position: 'front',
        hasSpacing: false,
        name: 'Guatemalan quetzal',
        symbol: 'Q',
      }, // Q1,000.00
      HKD: {
        position: 'front',
        hasSpacing: false,
        name: 'Hong Kong dollar',
        symbol: 'HK$',
      }, // $10,000.00
      HNL: {
        position: 'front',
        hasSpacing: false,
        name: 'Honduran lempira',
        symbol: 'L',
      }, // L1,000.00
      HTG: {
        position: 'front',
        hasSpacing: false,
        name: 'Haitian gourde',
        symbol: 'G',
      }, // G100,000
      HUF: {
        position: 'front',
        hasSpacing: false,
        name: 'Hungarian forint',
        symbol: 'Ft',
      }, // Ft300 000,00
      IDR: {
        position: 'front',
        hasSpacing: false,
        name: 'Indonesian rupiah',
        symbol: 'Rp',
      }, // Rp10.000.000
      ILS: {
        position: 'front',
        hasSpacing: false,
        name: 'Israeli new shekel',
        symbol: '₪',
      }, // ₪5.000.00
      INR: {
        position: 'front',
        hasSpacing: false,
        name: 'Indian rupee',
        symbol: '₹',
      }, // ₹75,000.00
      IQD: {
        position: 'front',
        hasSpacing: false,
        name: 'Iraqi dinar',
        symbol: 'ع.د',
      }, // ع.د1,000,000
      JMD: {
        position: 'front',
        hasSpacing: false,
        name: 'Jamaican dollar',
        symbol: '$',
      }, // $200,000
      JOD: {
        position: 'front',
        hasSpacing: false,
        name: 'Jordanian dinar',
        symbol: 'د.ا',
      }, // د.ا1000.00
      JPY: {
        position: 'front',
        hasSpacing: false,
        name: 'Japanese yen',
        symbol: '¥',
      }, // ¥100,000.00
      KES: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Kenyan shilling',
        symbol: 'KHs',
      }, // KSh 100.000
      KGS: {
        position: 'back',
        hasSpacing: false, // hasSpacing: true
        name: 'Kyrgyz som',
        symbol: 'сом',
      }, // 200,000 сом
      KHR: {
        position: 'front',
        hasSpacing: false,
        name: 'Cambodian riel',
        symbol: '៛',
      }, // ៛4,000,000
      KRW: {
        position: 'front',
        hasSpacing: false,
        name: 'South Korean won',
        symbol: '₩',
      }, // ₩1,000,000
      KWD: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Kuwaiti dinar',
        symbol: 'د.ك',
      }, // د.ك 500.00
      KZT: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Kazakhstani tenge',
        symbol: '₸',
      }, // ₸1 000 000
      LKR: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Sri Lankan rupee',
        symbol: 'Rs',
      }, // Rs 300,000
      LSL: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Lesotho loti',
        symbol: 'M',
      }, // M 1.000,00
      MAD: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Moroccan dirham',
        symbol: 'د.م.',
      }, // د.م. 10.000
      mBTC: {
        // From CSV
        position: 'back',
        hasSpacing: false,
        name: 'milli Bitcoin',
        symbol: 'mBTC',
        special: 'btc', // Carried over from original BTC/MBTC logic
      }, // 29.12345678mBTC
      MDL: {
        position: 'back',
        hasSpacing: false, // hasSpacing: true
        name: 'Moldovan leu',
        symbol: 'L',
      }, //  20 000,00 L
      MGA: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Malagasy ariary',
        symbol: 'Ar',
      }, // Ar 10.000.000
      MKD: {
        position: 'back',
        hasSpacing: false, // hasSpacing: true
        name: 'Macedonian denar',
        symbol: 'ден',
      }, // 60 000,00 ден
      MMK: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Burmese kyat',
        symbol: 'Ks',
      }, // Ks 4,000,000
      MNT: {
        position: 'front',
        hasSpacing: false,
        name: 'Mongolian tögrög',
        symbol: '₮',
      }, // ₮4,000,000
      MOP: {
        position: 'front',
        hasSpacing: false,
        name: 'Macanese pataca',
        symbol: 'MOP$',
      }, // MOP$10,000.00
      MUR: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Mauritian rupee',
        symbol: 'Rs',
      }, // Rs 100,000.00
      MVR: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Maldivian rufiyaa',
        symbol: 'Rf',
      }, // Rf 40,000.00
      MWK: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Malawian kwacha',
        symbol: 'MK',
      }, // MK 3,000,000
      MXN: {
        position: 'front',
        hasSpacing: false,
        name: 'Mexican peso',
        symbol: '$',
      }, // $20,000.00
      MYR: {
        position: 'back',
        hasSpacing: false, // hasSpacing: true
        name: 'Malaysian ringgit',
        symbol: 'RM',
      }, // 5,000.00 RM
      MZN: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Mozambican metical',
        symbol: 'MT',
      }, // MT 240 000,00
      NAD: {
        position: 'front',
        hasSpacing: false,
        name: 'Namibian dollar',
        symbol: 'N$',
      }, // N$40,000.00
      NGN: {
        position: 'front',
        hasSpacing: false,
        name: 'Nigerian naira',
        symbol: '₦',
      }, // ₦2,000,000
      NIO: {
        position: 'front',
        hasSpacing: false,
        name: 'Nicaraguan córdoba',
        symbol: 'C$',
      }, // C$40,000.00
      NOK: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Norwegian krone',
        symbol: 'kr',
      }, // kr 10 000,00
      NPR: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Nepalese rupee',
        symbol: 'Rs',
      }, // Rs 100,000
      NZD: {
        position: 'front',
        hasSpacing: false,
        name: 'New Zealand dollar',
        symbol: '$',
      }, // $1,000.00
      PAB: {
        position: 'front',
        hasSpacing: false,
        name: 'Panamanian balboa',
        symbol: '$',
      }, // $1,000.00
      PEN: {
        position: 'front',
        hasSpacing: false,
        name: 'Peruvian sol',
        symbol: 'S/',
      }, // S/4 000,00
      PGK: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Papua New Guinean kina',
        symbol: 'K',
      }, // K 4,000.00
      PHP: {
        position: 'front',
        hasSpacing: false,
        name: 'Philippine peso',
        symbol: '₱',
      }, // ₱50,000.00
      PKR: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Pakistani rupee',
        symbol: 'Rs',
      }, // Rs 1,200,000
      PLN: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Polish złoty',
        symbol: 'zł',
      }, // zł 5 000,00
      PYG: {
        position: 'front',
        hasSpacing: false,
        name: 'Paraguayan guaraní',
        symbol: '₲',
      }, // ₲10.000.000
      QAR: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Qatari riyal',
        symbol: 'ر.ق',
      }, // ر.ق 10.000
      RMN: {
        // This is an alias for CNY in your original, CSV has it as a separate entry
        position: 'front',
        hasSpacing: false,
        name: 'Renminbi',
        symbol: '¥',
      }, // ¥7,000.00
      RON: {
        position: 'back',
        hasSpacing: false, // hasSpacing: true
        name: 'Romanian leu',
        symbol: 'L',
      }, // 5.000,00 L
      RSD: {
        position: 'back',
        hasSpacing: false,
        name: 'Serbian dinar',
        symbol: 'Дин',
      }, // 100.000,00Дин
      RUB: {
        position: 'back',
        hasSpacing: false, // hasSpacing: true
        name: 'Russian ruble',
        symbol: '₽',
      }, // 60 000,00 ₽
      RWF: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Rwandan franc',
        symbol: 'RFw',
      }, // FRw 4 000 000
      SAR: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Saudi riyal',
        symbol: 'ر.س',
      }, //  ر.س 4000
      SBD: {
        position: 'front',
        hasSpacing: false,
        name: 'Solomon Islands dollar',
        symbol: 'SI$',
      }, // SI$32,000.00
      SCR: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Seychellois rupee',
        symbol: 'SR',
      }, // SR 40,000.00
      SEK: {
        position: 'back',
        hasSpacing: false, // hasSpacing: true
        name: 'Swedish krona',
        symbol: 'kr',
      }, // 10.000,00 kr
      SGD: {
        position: 'front',
        hasSpacing: false,
        name: 'Singapore dollar',
        symbol: 'S$',
      }, // S$1,000.00
      SLE: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Sierra Leonean leone',
        symbol: 'Le',
      }, // Le 80,000.00
      SSP: {
        position: 'front',
        hasSpacing: false,
        name: 'South Sudanese pound',
        symbol: '£',
      }, // £2,000,000
      SVC: {
        // New currency from CSV
        position: 'front',
        hasSpacing: false,
        name: 'Salvadorian Colón',
        symbol: '₡',
      }, // ₡10,000.00
      SYP: {
        position: 'front',
        hasSpacing: false,
        name: 'Syrian pound',
        symbol: 'ل.س',
      }, // ل.س10.000.000
      THB: {
        position: 'front',
        hasSpacing: false,
        name: 'Thai baht',
        symbol: '฿',
      }, // ฿30,000.00
      TJS: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Tajikistani somoni',
        symbol: 'ЅМ',
      }, // SM 40 000,00
      TMT: {
        position: 'back',
        hasSpacing: false, // hasSpacing: true
        name: 'Turkmenistani manat',
        symbol: 'm',
      }, // 4 000,00 m
      TND: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Tunisian dinar',
        symbol: 'د.ت',
      }, // د.ت 10,000.00
      TRY: {
        position: 'back',
        hasSpacing: false,
        name: 'Turkish lira',
        symbol: '₺',
      }, // 5.000,00₺
      TTD: {
        position: 'front',
        hasSpacing: false,
        name: 'Trinidad & Tobago dollar',
        symbol: 'TT$',
      }, // TT$10,000.00
      TWD: {
        position: 'front',
        hasSpacing: false,
        name: 'New Taiwan dollar',
        symbol: 'NT$',
      }, // NT$30,000.00
      TZS: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Tanzanian shilling',
        symbol: 'TSh',
      }, // TSh 12,000,000
      UAH: {
        position: 'back',
        hasSpacing: false,
        name: 'Ukrainian hryvnia',
        symbol: '₴',
      }, // 30 000,00₴
      UGX: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Ugandan shilling',
        symbol: 'USh',
      }, // USh 12,000,000
      USD: {
        position: 'front',
        hasSpacing: false,
        name: 'United States dollar',
        symbol: '$',
      }, // $1,000.00
      UYU: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Uruguayan peso',
        symbol: '$U',
      }, // $U 160.000
      UZS: {
        position: 'back',
        hasSpacing: false, // hasSpacing: true
        name: 'Uzbekistani sum',
        symbol: 'сўм',
      }, // 12 000 000 so’m
      VES: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Venezuelan sovereign bolívar',
        symbol: 'Bs.',
      }, // Bs. 280.000,00
      VND: {
        position: 'back',
        hasSpacing: false,
        name: 'Vietnamese đồng',
        symbol: '₫',
      }, // 20.000.000₫
      XAF: {
        position: 'back',
        hasSpacing: false, // hasSpacing: true
        name: 'Central African CFA franc',
        symbol: 'FCFA',
      }, // 1 000 000 FCFA
      XOF: {
        position: 'back',
        hasSpacing: false, // hasSpacing: true
        name: 'West African CFA franc',
        symbol: 'FCFA',
      }, // 1 000 000 FCFA
      ZAR: {
        position: 'front',
        hasSpacing: false,
        name: 'South African rand',
        symbol: 'R',
      }, // R15,000.00
      ZMW: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Zambian kwacha',
        symbol: 'K',
      }, // K 30,000.00
      MP1: {
        position: 'back',
        hasSpacing: false, // hasSpacing: true
        name: 'Miles Points 1',
        symbol: ' ',
      },
      JP1: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Japanese Point 1',
        symbol: 'P',
      },
      JP2: {
        position: 'front',
        hasSpacing: false, // hasSpacing: true
        name: 'Japanese Point 2',
        symbol: 'P',
      },
      MBTC: {
        position: 'back',
        hasSpacing: false,
        name: 'Milli Bitcoin',
        symbol: 'mBTC', // Trimmed symbol
      },
    };
  }

  public static get CURRENCY_LIST(): string[] {
    return Object.keys(this.CURRENCIES);
  }
}
